import { RescheduleWizardPage } from "@/features/move-occasions/components/reschedule-wizard-page";
import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/sale/$token")({
  head: () => appTitleHead("move-occasions-title"),
  component: SaleRescheduleRoute
});

function SaleRescheduleRoute() {
  const { token } = Route.useParams();
  return <RescheduleWizardPage token={token} />;
}
